export default function PHP_strcasecmp() {
  return (
    <div>
      <h1>PHP_strcasecmp</h1>
    </div>
  );
}
